import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a437039"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "imgText" }
const _hoisted_2 = { class: "c_form_item imgText_item_input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "c_form_item_title" }, "主持人名称：", -1))
const _hoisted_4 = {
  key: 0,
  class: "goods_list"
}
const _hoisted_5 = { class: "list_operate" }
const _hoisted_6 = { class: "goods_item_wrap c_scroll" }
const _hoisted_7 = {
  key: 0,
  class: "goods_item_img"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "goods_item_content" }
const _hoisted_10 = { class: "goods_item_title" }
const _hoisted_11 = { class: "goods_item_footer" }
const _hoisted_12 = { class: "goods_item_footer_edit" }
const _hoisted_13 = {
  key: 1,
  class: "empty_wrap"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { reactive, watch, ref, unref, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import { emptyDataImgTxt } from '@/assets';
import { Modal, message, notification } from 'ant-design-vue';
import type { Imodal } from '@/views/live/place/Place.vue';
import ModalCreateImgTxt from './ModalCreateImgTxt.vue';
import { ImgTextRelease, ImgTxt } from '../type';
import { dateFormat } from '@/utils/format/date';
import { getToken } from '@/plugins/cookie';
import https from '@/api/exportList';
import { useDebounce } from '@/hooks/useDebounce'; //防抖

interface IProps {
  modelValue: ImgTextRelease;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageTextRelease',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: ImgTextRelease;
};

const aModal = Modal;

const form = ref<ImgTextRelease>({
  host: '',
  content: [],
});
form.value = unref(props.modelValue);

watch(form, (newVal) => {
  emit('update:modelValue', newVal);
});
// operate
// const choice_all = ref(false);
const msgId = ref<null | number>();
const itemForm = ref<ImgTxt>({
  msg_id: '0',
  img: '',
  content: '',
  created_at: '',
});

//  modal
const createModal = reactive<Imodal>({
  title: '添加图文信息',
  visible: false,
  loading: false,
});

const onCloseCreateModal = () => {
  createModal.title = '添加图文信息';
  createModal.visible = false;
  createModal.loading = false;
  itemForm.value = {
    msg_id: form.value.content.length.toString(),
    img: '',
    content: '',
    created_at: '',
  };
};

const openCreateModal = (id?: number) => {
  msgId.value = id ?? null;
  if (id || id === 0) {
    createModal.title = '编辑图文信息';
    itemForm.value = form.value.content[id];
  }
  createModal.visible = true;
};
const reverseText = ref('正序');
const onReverse = () => {
  const temp = JSON.parse(JSON.stringify(form.value.content));
  form.value.content = temp.reverse();
  reverseText.value = reverseText.value === '正序' ? '倒序' : '正序';
};

const route = useRoute();
const token = getToken();
const messageTip = ref();
const { proxy }: any = getCurrentInstance();
const corn = ref(1);
const onExport = useDebounce(() => {
  const data = {
    studio_id: route.params.studioId,
    is_cron_download: corn.value,
    export: 3,
  };
  https
    .get_menus({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

const createMsg = () => {
  itemForm.value.created_at = dateFormat(new Date());
  if (msgId.value || msgId.value === 0) {
    form.value.content.splice(msgId.value, 1, itemForm.value);
    msgId.value = null;
  } else if (itemForm.value.content === '' && itemForm.value.img === '') {
    message.destroy();
    message.warn('内容不能为空');
  } else {
    form.value.content.unshift(itemForm.value);
  }
  onCloseCreateModal();
};

const removeMsg = (id: number) => {
  form.value.content.splice(id, 1);
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_input, {
        class: "c_input",
        size: "large",
        value: form.value.host,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.host) = $event)),
        maxlength: 15,
        placeholder: "请输入主持人名称"
      }, {
        suffix: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(form.value.host.length) + "/15", 1)
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    (form.value.content.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_button, {
                class: "mod_modal_btn sm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openCreateModal()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加")
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                class: "mod_modal_btn sm",
                onClick: onReverse
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(reverseText.value), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_a_button, {
              class: "mod_modal_btn sm",
              onClick: _unref(onExport)
            }, {
              default: _withCtx(() => [
                _createTextVNode("导出")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.content, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "goods_item",
                key: item.created_at
              }, [
                (item.img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("img", {
                        class: "img",
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h4", _hoisted_10, _toDisplayString(item.content), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(item.created_at) + " ", 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_button, {
                        class: "gifbtn",
                        type: "link",
                        onClick: ($event: any) => (openCreateModal(index))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("修改")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        class: "gifbtn",
                        type: "link",
                        onClick: ($event: any) => (removeMsg(index))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("img", {
            class: "empty_tbody_img",
            src: _unref(emptyDataImgTxt),
            alt: ""
          }, null, 8, _hoisted_14),
          _createElementVNode("p", null, [
            _createTextVNode(" 暂无信息，可点击 "),
            _createVNode(_component_a_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openCreateModal())),
              type: "link",
              class: "empty_tbody_link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加")
              ]),
              _: 1
            }),
            _createTextVNode(" 创建～ ")
          ]),
          _hoisted_15
        ])),
    _createVNode(_unref(aModal), {
      visible: createModal.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((createModal.visible) = $event)),
      title: createModal.title,
      centered: "",
      destoryOnClose: "",
      onCancel: onCloseCreateModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: onCloseCreateModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          loading: createModal.loading,
          onClick: createMsg
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(ModalCreateImgTxt, {
          modelValue: itemForm.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((itemForm).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})